import React from 'react';
import ContentLoader from 'react-content-loader';
import { fakeSettings } from '@/constants/constants';

const ModalEsimFake = () => {
  return (
    <div className="billDetailsFakePc">
      <div className="container">
        <div className="row">
      
            <ContentLoader
              height="200"
              width="980"
              {...fakeSettings}
            >
              <rect x="0" y="10" width="150" height="25" />
     
              <rect x="0" y="50" width="300" height="25" />

              <rect x="0" y="90" width="300" height="25" />

              <rect x="0" y="130" width="300" height="25" />
            </ContentLoader>
         
        </div>
      </div>
    </div>
  );
}


export default ModalEsimFake;
